import { FixedTime, IntervalTime, TimeType } from '../models/time.model';

export class TimeUtils {

  public static timeValidatorPattern = /^([01]\d|2[0-3]):([0-5]\d)$/;

  public static isTimeValid(time: string): boolean {
    const timeSplit = time.split(':');
    return timeSplit[0] && Number(timeSplit[0]) >= 0 &&
      Number(timeSplit[0]) <= 24 && timeSplit[1] &&
      Number(timeSplit[1]) <= 60 && Number(timeSplit[1]) >= 0;
  }

  // Return a value as 14:00, handle the seconds if present
  public static mapTimeToHoursAndSeconds(time: string | undefined): string {
    if (!time) {
      return '';
    }

    const timeParts = time.split(':');
    return `${timeParts[0].padStart(2, '0')}:${timeParts[1].padStart(2, '0')}`;
  }

  public static isFixedTime(time: FixedTime | IntervalTime | undefined): time is FixedTime {
    return TimeType.FIXED_TIME === time?.type;
  }

  public static isIntervalTime(time: FixedTime | IntervalTime | undefined): time is IntervalTime {
    return time?.type === TimeType.INTERVAL_TIME;
  }

}

